import { graphql } from "./generated/index.js"

// Merge operations =============================================================

// Delete links by ids (removing duplicates before merge).
export const deleteLinksByIds = graphql(`
  mutation deleteLinksByIds($ids: [Int!]!) {
    delete_record_links(where: { id: { _in: $ids } }) {
      affected_rows
      returning {
        id
      }
    }
  }
`)

// Insert many links in one mutation (the reference write path's batched add).
export const insertManyRecordLinks = graphql(`
  mutation insertManyRecordLinks($objects: [record_links_insert_input!]!) {
    insert_record_links(objects: $objects) {
      returning {
        ...RecordLinkFields
      }
    }
  }
`)

// Timeline queries =============================================================

// Admin queries ================================================================

